import AbsModule from '../common/AbsModule';
import { SEARCH_API_DOMAIN } from '../common/const';
import { serializeObject } from '../common/util';

// 상수로 넣어도 됨. 자동완성 기능만 있으면 되지, 굳이 최신 버전을 따라갈 필요는 없음. 만약 자동완성이 업그레이드 되면, 이것도 업그레이드 되어야 하겠지만..
const NCUI_VERSION = '1.7.20';

// (신) /uikit/ncui/${ncuiVersion}/js/ncui-autosuggest.js
export default class SearchAutoSuggestNcui extends AbsModule {
    constructor(_config, _isShow = true) {
        super(_config, _isShow);
    }

    startSetting() {
        if (typeof window.ncui.autoSuggest === 'undefined') {
            const PATH_SCRIPT = `/uikit/ncui/${NCUI_VERSION}/js/ncui-autosuggest.js`;
            const PATH_CSS = `/uikit/ncui/${NCUI_VERSION}/css/ncui-autosuggest.css`;

            const HOST = this.com.staticHost;
            const EL_SCRIPT = document.createElement('script');

            EL_SCRIPT.src = `${HOST}${PATH_SCRIPT}`;

            EL_SCRIPT.addEventListener('load', (e) => {
                this.setAutoSuggest();
            });

            document.body.appendChild(EL_SCRIPT);
        } else {
            this.setAutoSuggest();
        }
    }

    setAutoSuggest() {
        const searchData = this.moduleData.search || {};
        const queryStr = searchData.queryPattern || '?';
        const keywordParam = 'keyword';

        new window.ncui.autoSuggest({
            apiUrl: `${SEARCH_API_DOMAIN[this.com.env]}/${searchData.service}/search/v2/total/suggest`,
            addParam: {}, // api 에 추가로 붙여서 보낼 파람이 있을경우
            selector: '#nccSuggestForm', // 검색 form이 삽입될 컨테이너 selector
            size: 5, // 자동완성 리스트 갯수
            useDelbtn: true, // 검색어 삭제 버튼 활성화
            cookieName: '', // 최근검색어가 저장될 쿠키의 키네임
            locale: 'ko-KR', // locale 값
            keywordParamName: 'keyword',
            placeholderStr: searchData.placeholder || '통합검색', // placeholder 문구
            useCookie: false, // 쿠키를 사용해도 되는지여부 (1.7.20 추가)
            useDefaultCss: false,
            customeClassName: {
                suggest_form: '',
                suggest_input: 'ncc-search-input',
                suggest_delete: 'ncc-search-input-delete',
                suggest_submit: 'ncc-search-submit',
                suggest_wrap: 'ncc-suggest-list-wrap',
                suggest_list: 'ncc-suggest-list',
                suggest_scroll: 'suggest_scroll',
            },
            submitCallback: (_q) => {
                const _href =
                    searchData.destUrl +
                    queryStr +
                    serializeObject({
                        [keywordParam]: _q,
                        // where : this.moduleData.search.where,
                        // pos : this.moduleData.search.pos
                        site: searchData.service,
                    });
                location.href = _href;
            },
        });
    }

    makeMarkup() {
        let divEle = `
          <div id="nccSuggestForm"> </div>
          `;

        return divEle;
    }
}
